import React from 'react';
import styled from 'styled-components';

import * as Common from '../../Styles';
import { RemoveImageIcon } from './Icons';

const Theme = Common.Theme;

export const Container = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	padding-bottom: 50px;
	z-index: 101;
	height: 100vh;
	width: 100%;
	background: ${Theme.creamWhite};
	box-shadow: 0 0 15px ${Theme.shadow};
	font-family: Arial;
	transition: 2s;
	overflow: scroll;
	scroll-behavior: smooth !important;
	scrollbar-width: thin;
	scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
		border-radius: 5px;
	}
	&::-webkit-scrollbar-thumb {
		background: ${Theme.scrollThumb};
		border-radius: 5px;
		cursor: pointer !important;
	}
	&::-webkit-scrollbar-track {
		background: ${Theme.scrollBar};
	}
	@media only screen and (max-width: 1080px) {
		align-items: center;
	}
`;

export const ContainerHeading = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	justify-content: space-between;
	background-color: ${Theme.white};
	padding: 10px 10px;
	font-weight: bold;
	font-size: 16px;
	align-items: center;
`;

export const ContainerBody = styled.div`
	width: auto;
	max-width: 80rem;
	padding: 0.5rem;
	margin: 0 auto;
`;

export const HTMLContainer = styled.div`
	width: 100%;
	height: 100px;
	background: ${Theme.white};
	border-radius: 5px;
	padding: 16px 8px;
	resize: vertical;
	overflow: auto;
	overflow: scroll;
	scrollbar-width: thin;
	scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
		border-radius: 5px;
	}
	&::-webkit-scrollbar-thumb {
		background: ${Theme.scrollThumb};
		border-radius: 5px;
		cursor: pointer !important;
	}
	&::-webkit-scrollbar-track {
		background: ${Theme.scrollBar};
	}
`;

export const UploadImageSection = styled.div`
	width: auto;
	background-color: ${Theme.white};
	margin: 1rem;
	padding: 1rem;
`;

export const ProductImage = styled.img`
	height: 100%;
	max-height: 3rem;
	padding: 0.1rem;
`;

export const UploadedImage = styled(Common.FlexRow)`
	position: relative;
	width: auto;
	padding: 0.5rem;
	min-height: 3rem;
	font-size: 14px;
	border: 1px solid ${(props) => (props.checked ? Theme.blue : null)};
	border-radius: 10px;
	white-space: nowrap;
	align-items: center;
`;

export const UploadedImageGroup = ({ src, uploaded, onRemoveHandler }) => {
	return (
		<UploadedImage checked={uploaded}>
			<ProductImage
				src={src}
				alt={'Not Found'}
			/>
			<RemoveImageIcon
				onClick={(e) => {
					onRemoveHandler(e);
				}}
			/>
		</UploadedImage>
	);
};

export const Section = styled.div`
	width: auto !important;
	background: ${Theme.white} !important;
	margin: 0.5rem !important;
	padding: 1rem !important;
	border-radius: 0.5rem !important;
`;

export const SectionHeading = styled.div`
	display: flex;
	width: auto;
	margin: 0.5rem 0 0.5rem 0;
	font-size: 18px;
	font-weight: 700;
	line-height: 18px;
`;

export const SectionRow = styled(Common.FlexRow)`
	flex-wrap: wrap;
	row-gap: 0.1rem;
	column-gap: 0.5rem;
	align-items: start;
`;

export const NavigationLink = styled.a`
	width: auto;
	padding: 0.75rem 0.5rem;
	color: ${Theme.lightBlack};
	font-weight: 600;
	text-decoration: none;
	border: 0 solid ${Theme.shadow};
	border-bottom-width: 0.5px;

	&:hover {
		color: ${Theme.black};
	}
`;

export const LocalizationProvider = styled(Common.LocalizationProvider)``;

export const DatePicker = styled(Common.DatePicker)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const Message = styled(Common.Message)``;

export const Bold = styled(Common.Bold)``;

export const Tabs = styled(Common.Tabs)``;

export const Tab = styled(Common.Tab)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const SquareButton = styled(Common.SquareButton)``;

export const Search = styled(Common.Search).attrs((props) => ({
	style: {
		maxWidth: '100%',
	},
}))``;

export const InputMessage = styled(Common.InputMessage)``;

export const InputLength = styled(Common.InputLength)``;

export const InputGroup = styled(Common.InputGroup).attrs((props) => ({
	style: {
		flexBasis: 'calc(50% - 1rem)',
		rowGap: '0.15rem',
	},
}))``;

export const InputAdornment = styled(Common.InputAdornment)``;

export const TextField = styled(Common.TextField)``;

export const TextArea = styled(Common.TextArea)``;

export const RadioGroup = styled(Common.RadioGroup)``;

export const Select = styled(Common.Select)``;

export const SelectTitle = styled(Common.SelectTitle)``;

export const MenuItem = styled(Common.MenuItem)``;

export const ManufacturerMenuItem = styled(MenuItem)`
	text-transform: none !important;
`;

export const Number = styled(Common.Number)``;

export const FileUpload = styled(Common.FileUpload)``;

export const Chip = styled(Common.Chip)`
	margin: 0 0.25rem !important;
`;

export const TableContainer = styled(Common.TableContainer)`
	height: auto !important;
	width: auto !important;
	min-width: auto !important;
`;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)`
	padding: 0.5rem !important;
	&:first-child {
		padding-left: 0.5rem !important;
	}
	&:last-child {
		padding-right: 0.5rem !important;
	}
`;

export const TableBody = styled(Common.TableBody)``;

export const TableColumn = styled(Common.TableColumn)`
	padding: 0.25rem !important;
	font-weight: 400 !important;
	line-height: 2rem !important;
	&:first-child {
		padding-left: 0rem !important;
	}
	&:last-child {
		padding-right: 0rem !important;
	}
`;

export const TableRow = styled(Common.TableRow)`
	&:last-child ${TableColumn} {
		border-bottom-width: 0 !important;

		&:last-child {
			padding-top: 0.5rem !important;
		}
	}
`;

export const Pagination = styled(Common.Pagination)``;
